module.exports = __webpack_public_path__ + "img/steam-symbol.3b2dad11.svg";